import React from 'react';

import { type GatsbyBrowser, Script } from 'gatsby';
import { setupCookieSync, initialLandingPage, isBrowser } from '@lucid/utils';
import driftScript from '@lucid/utils/src/external/drift';

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  const maxAttempts = 3;
  let attempt = 0;
  const recordPage = () => {
    try {
      if (window.lucid && window.lucid.beacon) {
        window.lucid.beacon.recordPageChange(location.href);
      }
    } catch (e) {
      if (attempt < maxAttempts) {
        attempt += 1;
        setTimeout(() => recordPage(), 100);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  };

  if (isBrowser()) {
    if (prevLocation && window.lucid && window.lucid.beacon && !!window.lucid.beacon.recordPageChange) {
      setTimeout(() => recordPage(), 200);
    }
  }
};

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const iframeLocation = (window && window.location) || null;

  setupCookieSync(iframeLocation);
  initialLandingPage();
};

const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  if ('drift' in window) {
    return element;
  }
  return (
    <>
      {element}
      <Script id="drift-script" strategy="idle" type="text/javascript">
        {driftScript}
      </Script>
    </>
  );
};

export { onRouteUpdate, onInitialClientRender, wrapPageElement };
